import React from 'react';
import PropTypes from 'prop-types';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var TranslateContext = React.createContext();
var Provider = TranslateContext.Provider,
    Consumer = TranslateContext.Consumer;
var TranslateProvider = function TranslateProvider(_ref) {
  var translator = _ref.translator,
      children = _ref.children;
  return React.createElement(Provider, {
    value: translator
  }, children);
};
/* istanbul ignore next */

if (process.env.NODE_ENV !== 'production') {
  TranslateProvider.propTypes = {
    translator: PropTypes.shape({
      t: PropTypes.func.isRequired,
      parts: PropTypes.func.isRequired
    }).isRequired,
    children: PropTypes.node.isRequired
  };
}

var translate = function translate() {
  return function (Component) {
    return function (props) {
      return React.createElement(Consumer, null, function (translator) {
        return React.createElement(Component, _extends({}, props, {
          // eslint-disable-line react/jsx-props-no-spreading
          t: translator.t
        }));
      });
    };
  };
};
var useTranslator = function useTranslator() {
  return React.useContext(TranslateContext);
};
var Interpolate = function Interpolate(props) {
  return React.createElement(Consumer, null, function (translator) {
    return (// Manually use createElement so we're not passing an array as children to React.
      // Passing the array would require us to add keys to each interpolated element
      // but we know that the shape will stay the same so it's safe to spread it and act
      // as if they were all written as separate children by the user.
      React.createElement.apply(React, [React.Fragment, {}].concat(translator.parts(props.i18nKey, props)))
    );
  });
};
/* istanbul ignore next */

if (process.env.NODE_ENV !== 'production') {
  Interpolate.propTypes = {
    i18nKey: PropTypes.string.isRequired
  };
}

export { Interpolate, TranslateProvider, translate, useTranslator };
